export default [
  {
    id: 1,
    timestamp: '2017-09-08T11:22:33.3777388',
    name: 'SM Supermarket',
    description: 'SM Supermarket Order Template',
    performValidation: null,
    SapValidationResult: null,
    orderType: 'string',
    orderDate: null,
    soldTo: 'string',
    fromID: 'string',
    toID: 'string',
    requestedUnloadingDate: 'null',
    transport: 'string',
    globalType: 'string',
    transporter: 'string',
    licensePlate: 'string',
    customerRefNo: 'string',
    exchangePallets: 'string',
    noExchangePallets: 0,
    comments: 'string',
    LineItems: [
      {
        lineType: 'LT-01',
        palletID: 'string',
        packingID: 'string',
        palletStatus: 'string',
        packingStatus: 'string',
        logisticsVarietyPacking: 'string',
        packingsPerPallet: 0,
        noOfPallets: 0,
        packingQuantity: 0,
      },
      {
        lineType: 'LT-02',
        palletID: 'string',
        packingID: 'string',
        palletStatus: 'string',
        packingStatus: 'string',
        logisticsVarietyPacking: 'string',
        packingsPerPallet: 0,
        noOfPallets: 0,
        packingQuantity: 0,
      },
    ],
  },
  {
    id: 2,
    timestamp: '2017-09-08T11:23:11.0575985',
    name: 'Home Depot',
    description: 'Home Depot Order Template',
    performValidation: null,
    SapValidationResult: null,
    orderType: 'string',
    orderDate: null,
    soldTo: 'string',
    fromID: 'string',
    toID: 'string',
    requestedUnloadingDate: 'null',
    transport: 'string',
    globalType: 'string',
    transporter: 'string',
    licensePlate: 'string',
    customerRefNo: 'string',
    exchangePallets: 'string',
    noExchangePallets: 0,
    comments: 'string',
    LineItems: [
      {
        lineType: 'HD-01',
        palletID: 'string',
        packingID: 'string',
        palletStatus: 'string',
        packingStatus: 'string',
        logisticsVarietyPacking: 'string',
        packingsPerPallet: 0,
        noOfPallets: 0,
        packingQuantity: 0,
      },
      {
        lineType: 'HD-02',
        palletID: 'string',
        packingID: 'string',
        palletStatus: 'string',
        packingStatus: 'string',
        logisticsVarietyPacking: 'string',
        packingsPerPallet: 0,
        noOfPallets: 0,
        packingQuantity: 0,
      },
    ],
  },
  {
    id: 4,
    timestamp: '2017-10-04T11:59:35.962903',
    name: 'test',
    description: null,
    performValidation: 'False',
    SapValidationResult: null,
    orderType: 'EPS-CUS',
    orderDate: null,
    soldTo: '0001000140',
    fromID: 'BE11_001',
    toID: '0002000220',
    requestedUnloadingDate: 'null',
    transport: 'Z2',
    globalType: '',
    transporter: '',
    licensePlate: '',
    customerRefNo: null,
    exchangePallets: 'false',
    noExchangePallets: 0,
    comments: null,
    LineItems: [],
  },
  {
    id: 5,
    timestamp: '2017-10-04T13:59:53.6379418',
    name: 'test',
    description: null,
    performValidation: null,
    SapValidationResult: null,
    orderType: 'EPS-CUS',
    orderDate: null,
    soldTo: '0001000140',
    fromID: 'BE11_001',
    toID: '0002000220',
    requestedUnloadingDate: '2017-10-19',
    transport: 'Z2',
    globalType: '',
    transporter: '',
    licensePlate: '',
    customerRefNo: null,
    exchangePallets: 'false',
    noExchangePallets: 0,
    comments: null,
    LineItems: [],
  },
  {
    id: 6,
    timestamp: '2017-10-04T12:10:30.9878363',
    name: 'test 2',
    description: null,
    performValidation: 'False',
    SapValidationResult: null,
    orderType: 'EPS-CUS',
    orderDate: null,
    soldTo: '0001000140',
    fromID: 'BE11_001',
    toID: '0002000220',
    requestedUnloadingDate: 'null',
    transport: 'Z2',
    globalType: '',
    transporter: '',
    licensePlate: '',
    customerRefNo: null,
    exchangePallets: 'false',
    noExchangePallets: 0,
    comments: null,
    LineItems: [],
  },
];
